import { render, staticRenderFns } from "./BindFeatureValuesDialog.vue?vue&type=template&id=c8b33f86"
import script from "./BindFeatureValuesDialog.vue?vue&type=script&lang=js"
export * from "./BindFeatureValuesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports